"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.4771 6.4771 2 12 2c5.5228 0 10 4.4771 10 10 0 5.5228-4.4772 10-10 10-5.5229 0-10-4.4772-10-10zm8.5-7.8596C6.7987 4.8425 4 8.0944 4 12c0 1.1372.2373 2.2189.665 3.1984l5.835-3.7448V4.1404zM5.6894 16.9175C7.1534 18.7936 9.4358 20 12 20c2.7209 0 5.1246-1.3584 6.5698-3.4339l-6.5042-3.7408-6.3762 4.0922z"
  })];
};

exports.default = _default;